/** Mirrors `ActivityMetaKeys` in the API. */
export enum ActivityMetaKeys {
  INSERT = "INSERT",
  PATCH = "PATCH",
  REMOVE = "REMOVE",
  NEW_ASSIGNEES = "ASSIGNEES",
  NEW_ORDER = "NEW_ORDER",
  PREV_ORDER = "PREV_ORDER",
  MARK_DELETE = "MARK_DELETE",
  MARK_DELETE_UNDO = "MARK_DELETE_UNDO",
  CONVERT_TO = "CONVERT_TO",
  EXPORT = "EXPORT",
  IMPORT = "IMPORT",
  ATTACH_TASK = "ATTACH_TASK",
  ATTACH_MODULE = "ATTACH_MODULE",
  DETACH_MODULE = "DETACH_MODULE",
  ATTACH_KANBAN_CARD = "ATTACH_KANBAN_CARD",
  MERGE = "MERGE",
  MOVE = "MOVE",
  CHANGE_COLUMN = "CHANGE_COLUMN",
  CHANGE_KANBAN = "CHANGE_KANBAN",
  ATTACH = "ATTACH",
  DELETE = "DELETE",
  TAGS = "TAGS",

  //
  IS_BULK = "IS_BULK",
}

/** Keys that qualify another key rather than carrying a payload of their own. */
export const ACTIVITY_META_MODIFIER_KEYS: string[] = [
  "shared",
  ActivityMetaKeys.IS_BULK,
];
